import React from 'react';
import { Badge } from '../ui/Badge';
import { ArrowDownIcon, ArrowUpIcon, ClockIcon } from 'lucide-react';
interface AuditEvent {
  id: string;
  timestamp: string;
  direction: 'ingress' | 'egress';
  method: string;
  decision: 'allowed' | 'denied';
  reason?: string;
  latency?: number;
}
interface AuditTimelineProps {
  events: AuditEvent[];
  onEventClick?: (event: AuditEvent) => void;
}
export function AuditTimeline({
  events,
  onEventClick
}: AuditTimelineProps) {
  return <div className="space-y-1" data-id="element-25">
      {events.map(event => <button key={event.id} onClick={() => onEventClick?.(event)} className="w-full flex items-center gap-3 px-3 py-2 text-left hover:bg-slate-50 dark:hover:bg-slate-800 rounded-md transition-colors" data-id="element-26">
          {/* Direction Icon */}
          <div className={`p-1 rounded ${event.direction === 'ingress' ? 'bg-blue-50 dark:bg-blue-900/20' : 'bg-slate-100 dark:bg-slate-800'}`} data-id="element-27">
            {event.direction === 'ingress' ? <ArrowDownIcon className="h-3.5 w-3.5 text-blue-600 dark:text-blue-400" data-id="element-28" /> : <ArrowUpIcon className="h-3.5 w-3.5 text-slate-600 dark:text-slate-400" data-id="element-29" />}
          </div>

          {/* Method */}
          <div className="flex-1 min-w-0" data-id="element-30">
            <span className="text-sm font-mono text-slate-900 dark:text-slate-100" data-id="element-31">
              {event.method}
            </span>
            {event.reason && <p className="text-xs text-slate-500 dark:text-slate-400 truncate" data-id="element-32">
                {event.reason}
              </p>}
          </div>

          {/* Decision Badge */}
          <Badge variant={event.decision} size="sm" data-id="element-33">
            {event.decision}
          </Badge>

          {/* Timestamp & Latency */}
          <div className="text-right flex-shrink-0" data-id="element-34">
            <div className="text-xs text-slate-500 dark:text-slate-400" data-id="element-35">
              {event.timestamp}
            </div>
            {event.latency !== undefined && <div className="text-xs text-slate-400 dark:text-slate-500 flex items-center gap-0.5 justify-end" data-id="element-36">
                <ClockIcon className="h-3 w-3" data-id="element-37" />
                {event.latency}ms
              </div>}
          </div>
        </button>)}
    </div>;
}
export type { AuditEvent };